// Dom7
import Dom7 from "dom7";

window.$ = Dom7;
window.$$ = Dom7;

export default $;



// jQuery
// import $ from 'jquery-slim/dist/jquery.slim';
//
// window.$ = $;
// window.jQuery = $;
//
// export default $;
